export const NitrateNitrogenPrefix = 'n-no3';